export enum ApplicationState {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    REFUSED = 'REFUSED',
    ACCEPTED = 'ACCEPTED',
}

export enum ApplicationStateActions {
    SUBMIT = 'SUBMIT',
    DONE = 'DONE',
    GIVE_UP = 'GIVE_UP',
}
